import { render, staticRenderFns } from "./ElSpace.vue?vue&type=template&id=31072d63&"
import script from "./ElSpace.vue?vue&type=script&lang=js&"
export * from "./ElSpace.vue?vue&type=script&lang=js&"
import style0 from "./ElSpace.vue?vue&type=style&index=0&id=31072d63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports